import { LoadingStatusType } from "@/enums/enums";
import API from "@/service/Index";
import { ConvertToSalaryCommentLog } from "@/service/salary/salaryFacade";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";

@Module({ namespaced: true })
class Comment extends VuexModule {
  public commentListLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public commentList: any = [];
  public addCommentLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public voidCommentLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private commentSalaryId = 0;

  get getCommentListLoadingStatus(): LoadingStatusType {
    return this.commentListLoadingStatus;
  }
  get getCommentList(): any {
    return this.commentList;
  }
  get getAddCommentLoadingStatus(): LoadingStatusType {
    return this.addCommentLoadingStatus;
  }
  get getVoidCommentLoadingStatus(): LoadingStatusType {
    return this.voidCommentLoadingStatus;
  }

  @Mutation
  public SetCommentListLoadingStatus(status: LoadingStatusType) {
    this.commentListLoadingStatus = status;
  }
  @Mutation
  public SetCommentList(commentList: any) {
    this.commentList = commentList;
  }
  @Mutation
  public SetAddCommentLoadingStatus(status: LoadingStatusType) {
    this.addCommentLoadingStatus = status;
  }
  @Mutation
  public SetVoidCommentLoadingStatus(status: LoadingStatusType) {
    this.voidCommentLoadingStatus = status;
  }
  @Mutation
  public SetCommentSalaryId(salaryId: number) {
    this.commentSalaryId = salaryId;
  }

  @Action
  public DoGetCommentList(input: any) {
    if (this.commentSalaryId !== input.salaryId && this.commentListLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetCommentListLoadingStatus", LoadingStatusType.Loading);
      this.context.commit("SetCommentSalaryId", input.salaryId);
      API.SalaryService.DoGetSalaryCommentLog(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          const commentLogPndList = ConvertToSalaryCommentLog(res.data.commentLogList);
          this.context.commit("SetCommentList", commentLogPndList);
        }
        this.context.commit("SetCommentListLoadingStatus", LoadingStatusType.Success);
      });
    }
  }

  @Action
  public DoAddComment(input: any) {
    if (this.commentListLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetAddCommentLoadingStatus", LoadingStatusType.Loading);
      API.SalaryService.DoAddSalaryCommentLog(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          const inputDataForGet = { salaryId: input.InsertCommentLog.id, documentType: input.documentType };
          API.SalaryService.DoGetSalaryCommentLog(inputDataForGet).then((res) => {
            if (res.data.responseCode.IsSuccess()) {
              const commentList = ConvertToSalaryCommentLog(res.data.commentLogList);
              this.context.commit("SetCommentList", commentList);
              this.context.commit("SetAddCommentLoadingStatus", LoadingStatusType.Success);
            }
          });
        }
      });
    }
  }

  @Action
  public DoVoidComment(input: any) {
    if (this.commentListLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("SetVoidCommentLoadingStatus", LoadingStatusType.Loading);
      API.SalaryService.DoVoidSalaryCommentLog(input).then((res) => {
        if (res.data.responseCode.IsSuccess()) {
          const inputDataForGet = { salaryId: input.voidCommentLog.id, documentType: input.documentType };
          API.SalaryService.DoGetSalaryCommentLog(inputDataForGet).then((res) => {
            if (res.data.responseCode.IsSuccess()) {
              const commentLogPP30List = ConvertToSalaryCommentLog(res.data.commentLogList);
              this.context.commit("SetCommentList", commentLogPP30List);
              this.context.commit("SetVoidCommentLoadingStatus", LoadingStatusType.Success);
            }
          });
        }
      });
    }
  }
}
export default Comment;
